import React from 'react';
import Icon from '../../../components/AppIcon';

const ObjectionCard = ({ objection, onSelect }) => {
  const getDifficultyColor = (difficulty) => {
    if (difficulty <= 2) return 'text-success bg-success/10';
    if (difficulty <= 3) return 'text-warning bg-warning/10';
    return 'text-error bg-error/10';
  };

  const getDifficultyLabel = (difficulty) => {
    if (difficulty <= 2) return 'Beginner';
    if (difficulty <= 3) return 'Intermediate';
    return 'Advanced';
  };

  return (
    <div 
      className="bg-card rounded-xl p-6 border border-border hover:shadow-elevated hover:border-primary/30 transition-all duration-200 cursor-pointer group" 
      onClick={() => onSelect(objection)}
    >
      <div className="flex items-start justify-between mb-4">
        <div className="flex-1">
          {/* Difficulty and Status badges */}
          <div className="flex items-center gap-2 mb-3">
            <span className={`text-xs font-semibold px-3 py-1 rounded-full ${getDifficultyColor(objection?.difficulty)}`}>
              {getDifficultyLabel(objection?.difficulty)}
            </span>
            {objection?.status && (
              <span className={`text-xs font-semibold px-3 py-1 rounded-full ${objection?.statusColor}`}>
                {objection?.status}
              </span>
            )}
          </div>

          {/* Objection statement - main focus */}
          <h3 className="text-lg font-semibold text-foreground mb-3 group-hover:text-primary transition-colors">
            &ldquo;{objection?.statement}&rdquo;
          </h3>

          {/* Status information instead of answer */}
          {objection?.avgScore > 0 && (
            <div className="flex items-center gap-2 text-sm text-muted-foreground">
              <Icon name="TrendingUp" size={16} />
              <span>Your average: {objection?.avgScore}%</span>
            </div>
          )}

          {/* Tags */}
          {objection?.tags && (
            <div className="flex flex-wrap gap-2 mt-3">
              {objection?.tags?.split(',')?.slice(0, 3)?.map((tag, index) => (
                <span 
                  key={index} 
                  className="text-xs px-3 py-1 bg-muted border border-border text-muted-foreground rounded-full"
                >
                  {tag?.trim()}
                </span>
              ))}
            </div>
          )}
        </div>
        
        <Icon 
          name="ChevronRight" 
          size={20} 
          className="text-muted-foreground group-hover:text-primary transition-colors flex-shrink-0 ml-4" 
        />
      </div>

      {/* Practice prompt */}
      <div className="pt-4 border-t border-border">
        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <Icon name="Target" size={16} />
          <span>Click to practice this objection</span>
        </div>
      </div>
    </div>
  );
};

export default ObjectionCard;